module.exports = __webpack_public_path__ + "static/media/08.e15142ad.jpg";